module.exports = __webpack_public_path__ + "img/SNSBANK.116a1ffd.jpg";